var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    stroke: "#021317",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 10.9167H14C13.0792 10.9167 12.3333 10.1709 12.3333 9.25008C12.3333 8.32925 13.0792 7.58341 14 7.58341H15.6667M15.6667 10.9167C16.1267 10.9167 16.5 10.5434 16.5 10.0834V8.41675C16.5 7.95675 16.1267 7.58341 15.6667 7.58341M15.6667 10.9167V13.4167C15.6667 14.3376 14.9208 15.0834 14 15.0834H3.16667C2.24583 15.0834 1.5 14.3376 1.5 13.4167V2.16675M15.6667 7.58341V5.08341C15.6667 4.16258 14.9208 3.41675 14 3.41675H2.75C2.06 3.41675 1.5 2.85675 1.5 2.16675M1.5 2.16675C1.5 1.47675 2.06 0.916748 2.75 0.916748H13.1667",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.acf14cdbda9934f30131f250b6d9f544.svg";
export { ForwardRef as ReactComponent };